// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"61a5468c","396":"1012c5f7"}[chunkId] + ".chunk.js";
};